// src/i18n.js

import { createI18n } from 'vue-i18n';
import en from '@/assets/i18n/en.json';
import it from '@/assets/i18n/it.json';
import de from '@/assets/i18n/de.json';
import es from '@/assets/i18n/es.json';
import fr from '@/assets/i18n/fr.json';
import jp from '@/assets/i18n/jp.json';
import pt from '@/assets/i18n/pt.json';
import ru from '@/assets/i18n/ru.json';
import sv from '@/assets/i18n/sv.json';
import { USER_LANG } from 'core/constants'


const messages = {
  en,
  it,
  de,
  es,
  fr,
  //jp,
  pt,
  ru,
  sv
};

const lg = localStorage.getItem(USER_LANG)
if(!lg){
  localStorage.setItem(USER_LANG, 'en')
}

const changeLang = (lang: string) => {
  localStorage.setItem(USER_LANG, lang)
}

const i18n = createI18n({
  locale: localStorage.getItem(USER_LANG) || 'en', 
  fallbackLocale: 'en',
  messages,
});

export default i18n;
export { changeLang }
